export type GetComponentProjectListRequest = {
  dipByRgn?: string;
  rootCpntId?: string;
  cpntId?: string;
  cpntPjtTypeCd?: string;
  cpntPrtclCtgryTypeCd?: string;
  inOutTypeCd?: string;
  prtcolTypeCd?: string;
  cpntPjtSts?: string[];
  ifpjtName?: string;
  ifpjtId?: string;
  cpntList?: GetCpntPjtCpntKey[];
};
export type GetCpntPjtCpntKey = {
  dipByRgn: string;
  cpntId: string;
};
